<foldout class={state.active ? 'active' : ''}>
  <div data-id="body">
    <slot />
  </div>

  <a
    href="#"
    onclick={event => toggle(event)}
    class="d-block mt-2"
  >{label()}</a>
  
  <script>
    import {util} from '@wendig/lib'

    export default class {
      onBeforeMount(props, state) {
        state.active = false
      }

      onMounted(props, state) {
        const element = this.root.querySelector("[data-id='body']")

        const transition = element.style['transition']
        element.style.setProperty('--auto-height', `auto`)
        element.style['transition'] = ''

        this.update({active: true})

        window.requestAnimationFrame(() => {
          element.style.setProperty('--auto-height', `${element.offsetHeight}px`)
          this.update({active: false})

          element.style['transition'] = transition
        })
      }

      toggle(event) {
        event.preventDefault()

        this.update({active: !this.state.active})
      }

      label() {
        return this.state.active ?
          this.t('read_less') :
          this.t('read_more')
      }
    }
  </script>
</foldout>
